import { BrandclubProductCard } from '../BrandclubProductCard/index.js';
import { TABLET_SCREEN_SIZE, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING } from '../../../utils/constants/Constants.js';
import React from 'react';
import { styled } from '@mui/material';

var _a, _b;
var Title = styled('div')((_a = {
        fontSize: 30,
        fontWeight: 'bold',
        marginBottom: 30
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        padding: "".concat(0, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
    },
    _a["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
        padding: "".concat(0, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
    },
    _a));
var ProductGrid = styled('div')((_b = {
        display: 'grid',
        gridTemplateColumns: "repeat(5, 1fr)",
        justifyContent: 'space-between',
        gridGap: 20
    },
    _b["@media screen and (max-width: ".concat(1250, "px)")] = {
        gridTemplateColumns: "repeat(4, 1fr)",
    },
    _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        gridTemplateColumns: "repeat(3, 1fr)",
        padding: "0px ".concat(MOBILE_HORIZONTAL_PADDING, "px"),
    },
    _b["@media screen and (max-width: ".concat((TABLET_SCREEN_SIZE + MOBILE_SCREEN_SIZE) / 2, "px)")] = {
        gridTemplateColumns: "repeat(2, 1fr)",
        gridGap: 10,
    },
    _b));
var BrandclubProductGrid = function (_a) {
    var title = _a.title, products = _a.products, LinkComponent = _a.LinkComponent, onShareClick = _a.onShareClick;
    return (React.createElement("div", null,
        title && React.createElement(Title, null, title),
        React.createElement(ProductGrid, null, products.map(function (product, idx) {
            return (React.createElement(BrandclubProductCard, { onShareClick: function (e) {
                    if (onShareClick) {
                        onShareClick(e, product);
                    }
                }, LinkComponent: LinkComponent, key: idx, product: product }));
        }))));
};

export { BrandclubProductGrid as default };
//# sourceMappingURL=index.js.map
